import type { EsmsTypeAgg } from '../../types/esms';
import InfoTooltip from '../revenue/InfoTooltip';

function formatVND(v: number): string { return v.toLocaleString('en-US'); }
function formatNum(v: number): string { return v.toLocaleString('en-US'); }

export default function EsmsByTypeTable({ byType, isDark }: { byType: EsmsTypeAgg[]; isDark: boolean }) {
  const totalSms = byType.reduce((s, b) => s + b.sms_count, 0);
  const totalCost = byType.reduce((s, b) => s + b.total_cost, 0);

  return (
    <div className={`backdrop-blur rounded-lg p-4 sm:p-6 ${isDark ? 'bg-white/10' : 'bg-white border border-gray-200 shadow-sm'}`}>
      <h3 className={`text-lg font-semibold mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`}>
        Breakdown theo loại tin nhắn
        <InfoTooltip isDark={isDark} text={'Thống kê SMS & chi phí theo SmsType.\n• 1: Advertising (tin quảng cáo)\n• 2: CSKH (chăm sóc khách hàng)\n• 8: Budget (tin tiết kiệm)\n• 23: Viber\n• 24: Zalo Priority\n• 25: Zalo Standard'} />
      </h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className={isDark ? 'border-b border-white/10' : 'border-b border-gray-200'}>
              <th className={`text-left px-2 sm:px-3 py-2 font-medium ${isDark ? 'text-slate-300' : 'text-gray-600'}`}>Loại</th>
              <th className={`text-right px-2 sm:px-3 py-2 font-medium ${isDark ? 'text-slate-300' : 'text-gray-600'}`}>SMS</th>
              <th className={`hidden sm:table-cell text-right px-3 py-2 font-medium ${isDark ? 'text-slate-300' : 'text-gray-600'}`}>Thành công</th>
              <th className={`hidden sm:table-cell text-right px-3 py-2 font-medium ${isDark ? 'text-slate-300' : 'text-gray-600'}`}>Thất bại</th>
              <th className={`text-right px-2 sm:px-3 py-2 font-medium ${isDark ? 'text-slate-300' : 'text-gray-600'}`}>Chi phí (VND)</th>
            </tr>
          </thead>
          <tbody>
            {byType.map((r) => (
              <tr key={r.smsType} className={isDark ? 'border-b border-white/5' : 'border-b border-gray-100'}>
                <td className={`px-2 sm:px-3 py-2 ${isDark ? 'text-slate-200' : 'text-gray-800'}`}>{r.label} <span className="opacity-60">({r.smsType})</span></td>
                <td className={`px-2 sm:px-3 py-2 text-right font-mono ${isDark ? 'text-cyan-300' : 'text-gray-900'}`}>{formatNum(r.sms_count)}</td>
                <td className={`hidden sm:table-cell px-3 py-2 text-right font-mono ${isDark ? 'text-emerald-300' : 'text-gray-900'}`}>{formatNum(r.success_count)}</td>
                <td className={`hidden sm:table-cell px-3 py-2 text-right font-mono ${isDark ? 'text-rose-300' : 'text-gray-900'}`}>{formatNum(r.failed_count)}</td>
                <td className={`px-2 sm:px-3 py-2 text-right font-mono ${isDark ? 'text-amber-300' : 'text-gray-900'}`}>{formatVND(r.total_cost)}</td>
              </tr>
            ))}
            <tr className={isDark ? 'bg-white/5' : 'bg-gray-100'}>
              <td className={`px-2 sm:px-3 py-2 font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>TỔNG</td>
              <td className={`px-2 sm:px-3 py-2 text-right font-mono font-semibold ${isDark ? 'text-cyan-300' : 'text-gray-900'}`}>{formatNum(totalSms)}</td>
              <td className="hidden sm:table-cell" />
              <td className="hidden sm:table-cell" />
              <td className={`px-2 sm:px-3 py-2 text-right font-mono font-semibold ${isDark ? 'text-amber-300' : 'text-gray-900'}`}>{formatVND(totalCost)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
